import { Switch } from "@/components/primitives/switch";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  getSoundNotificationPreference,
  setSoundNotificationPreference,
} from "@/utils/audioUtils";

/**
 * Purpose: Reusable switch component for toggling sound notifications
 *
 * How it works:
 * 1. Displays a switch toggle for sound notification preference
 * 2. Persists preference to localStorage
 * 3. Provides immediate feedback on state changes
 *
 * Key features:
 * - Persistent preference storage
 * - Accessible switch control
 * - Internationalization support
 */

export const SoundNotificationSwitch: React.FC = () => {
  const { t } = useTranslation();
  const [isEnabled, setIsEnabled] = useState(false);

  // Load the initial preference state
  useEffect(() => {
    setIsEnabled(getSoundNotificationPreference());
  }, []);

  const handleToggle = (checked: boolean) => {
    setIsEnabled(checked);
    setSoundNotificationPreference(checked);
  };

  return (
    <div className="flex items-center justify-between py-2">
      <span>{t("inAppAudioNotifications")}</span>
      <Switch
        checked={isEnabled}
        onCheckedChange={handleToggle}
        aria-label={t("inAppAudioNotifications")}
      />
    </div>
  );
};
